import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {LoginRigthBg} from '../imagepath';
import { BtnLoading } from '../ui/BtnUi';
import { Alerte_Error } from '../ui/AlertesUi';
import { DefaultSpinner } from '../ui/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import { GetUserToken } from '../backend/store/Accounts/Dispatchs';
import './LoginDemo.css';

const manualDemoAccounts = [
  { label: 'Archiviste', username: 'demo_archiviste' },
  { label: 'Assistant archivage', username: 'demo_assistant' },
  { label: 'Lecteur', username: 'demo_lecteur' },
];
const publicDemoPassword = (process.env.REACT_APP_DEMO_PASSWORD || '').trim();

const Login = (props) => {
const [isLogin , setIsLogin] = useState(null);

const [userLogin, setUserLogin] = useState('')
const [userPwd, setUserPwd] = useState('') 
const demoAccounts = process.env.REACT_APP_DEMO_ACCOUNTS_ENABLED === 'true' ? manualDemoAccounts : [];
const Navigate = useNavigate()
const sessionExpired = new URLSearchParams(useLocation().search).has('sessionExpired');

const state = useSelector(state => state.sessionAuth)
const dispatch = useDispatch()

const LoginFormSubmit = e =>{
e.preventDefault();

const Login = {
username: userLogin,
password: userPwd
}
setUserPwd('');
//appel de Axios et dispatch des actions
dispatch(GetUserToken(Login, Navigate))

}

useEffect(()=>{

setTimeout(()=>{
setIsLogin(state.isAuthenticated)
},[1000])
},[isLogin, state.isAuthenticated])


return isLogin === null ? (DefaultSpinner('Chargement login datas ...')) : 
isLogin ? (Navigate(`/apps/in/dashboard/${state.sessionId}`, {replace: true}))  : (
<Fragment>
<div className="content2">
<div className="container-fluid">
<div className="row">
<div className="account-content">
<div className="row align-items-center justify-content-center account_block">

{/** block login*/}
<div className="col-md-12 col-lg-5 login-right">
<div className="login-header text-center">
<h3 style={{marginBottom: '10px'}}>Se connecter </h3>
<i className="ri-user-6-line"></i>
</div>
{sessionExpired && <div className="alert alert-info" role="alert">Votre session a expiré. Veuillez vous reconnecter.</div>}
<div>

<form name='loginForm' onSubmit={LoginFormSubmit}>
<div className="form-group form-focus">

<input type="text" className="form-control" 
value={userLogin}
onChange={e => setUserLogin(e.target.value)} required autoComplete='username'/>
<label className="focus-label">Nom d'utilisateur</label>
</div>

<div className="form-group form-focus">
<input type="password" className="form-control floating" 
value={userPwd}
onChange={e => setUserPwd(e.target.value)} required/>
<label className="focus-label">Votre mot de passe</label>
</div>


{ /** afficahe du button connexion et chargement */
!state.isLoading ? (<button className="btn btn-primary btn-block btn-lg login-btn" 
type="submit">
Se connecter
</button>):(BtnLoading('Connexion'))

} 


</form>

<div className="text-center mt-3"><a href="/mot-de-passe-oublie">Mot de passe oublié ?</a></div>


</div>
{demoAccounts.length > 0 && (
<section className="login-demo" aria-labelledby="login-demo-title">
  <h4 id="login-demo-title">Comptes de démonstration</h4>
  <p>Choisissez un profil pour renseigner les identifiants de démonstration.</p>
  {!publicDemoPassword && <p className="login-demo-notice">Le mot de passe de démonstration n’est pas configuré pour cette instance.</p>}
  <div className="login-demo-list">
    {demoAccounts.map(account => (
      <button
        key={account.username}
        type="button"
        className="login-demo-account"
        onClick={() => {
          setUserLogin(account.username);
          setUserPwd(publicDemoPassword);
        }}
      >
        <span className="login-demo-role">{account.label}</span>
        <span className="login-demo-credentials">
          <span><strong>Nom d’utilisateur</strong><code>{account.username}</code></span>
          <span><strong>Mot de passe</strong><code>{publicDemoPassword || 'Non configuré'}</code></span>
        </span>
      </button>
    ))}
  </div>
</section>
)}
<div className='loginError'>
{/** messages erreur login */}
{state.loginError && Alerte_Error(' Échec de la tentative de connexion, vérifiez vos identifiants ')}
{/** //messages erreur login */}
</div>
</div>
{/** imaage droite */}
<div className="col-md-7 col-lg-6 login">
<img src={LoginRigthBg} className="img-fluid" alt="Login" />	
</div>

</div>
</div>
</div>
</div>
</div>
</Fragment>
)
}

export default Login
